// extracted by mini-css-extract-plugin
module.exports = {"textLink":"FaqBlock_textLink__jZino","arrow":"FaqBlock_arrow__OxLyM"};